module.exports = __webpack_public_path__ + "img/stacees-pb2-shake.337bfeee.jpg";